import React from 'react';
import PropTypes from 'prop-types';
import { AddCircleOutline } from '@material-ui/icons';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const Styled = styled.span`
  padding: 10px;
  vertical-align: middle;
`;

function Add({ title, onClick }) {
  return (
    <Styled onClick={onClick}>
      <Tooltip title={<FormattedMessage id={title} defaultMessage={title} />}>
        <AddCircleOutline />
      </Tooltip>
    </Styled>
  );
}

Add.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

Add.defaultProps = {
  title: '',
  onClick: () => {},
};

export default Add;
